// LSG Grid Sizes
export const LSG_GRID_SIZES = {
  CUSTOM: 'custom',
  ONE_BY_ONE: '1x1',
  THREE_BY_THREE: '3x3',
  FIVE_BY_FIVE: '5x5',
  SEVEN_BY_SEVEN: '7x7',
  NINE_BY_NINE: '9x9',
  ELEVEN_BY_ELEVEN: '11x11',
  THIRTEEN_BY_THIRTEEN: '13x13',
  FIFTEEN_BY_FIFTEEN: '15x15'
} as const;

// LSG Report Run Statuses
export const LSG_RUN_STATUS = {
  CREATED: 'created',
  RUNNING: 'running',
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  PROCESSING: 'processing',
  NOT_ENOUGH_CREDITS: 'not_enough_credits'
} as const;

// LSG Report Run Visibility
export const LSG_RUN_VISIBILITY = {
  ACTIVE: 'active',
  ARCHIVED: 'archived'
} as const;
